<section class="datatable datatable--flat notes-component">
    <header class="datatable__header notes-component__header">
        <div class="datatable-toolbar notes-component__toolbar">
            <div class="datatable-toolbar-start notes-component__toolbar-start">
                <div class="datatable__search notes-component__search-wrap">
                    <div class="datatable__search-field">
                        <i-feather name="search"></i-feather>
                        <input type="text" [placeholder]="'SEARCH' | translate" class="datatable__search-input notes-component__search-input" [(ngModel)]="searchString"
                            (keydown.enter)="doNoteSearch()">
                    </div>
                </div>
                <div *ngIf="!iIsExternal" class="notes-component__filter-wrap">
                    <ng-select
                        class="notes-component__filter"
                        [items]="filterOptions"
                        bindLabel="labelKey"
                        bindValue="value"
                        [clearable]="false"
                        [searchable]="false"
                        [(ngModel)]="filterBy"
                        (change)="refreshNotes()">
                        <ng-template ng-option-tmp let-item="item">
                            {{ item.labelKey | translate }}
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                            {{ item.labelKey | translate }}
                        </ng-template>
                    </ng-select>
                </div>
            </div>

            <div class="datatable-toolbar-end notes-component__actions">
                <div class="datatable__pagination-group pagination-rounded notes-component__header-pagination-group">
                    <div class="datatable__pagination notes-component__pagination">
                        <ngb-pagination [maxSize]="1" [rotate]="true" [ellipses]="true"
                            [collectionSize]="notesData.length" [page]="pageNumber" [boundaryLinks]="true"
                            (pageChange)="onPageChange($event)" [pageSize]="pageSize">
                        </ngb-pagination>
                    </div>
                </div>
                <div *ngIf="iCanWrite || iIsAdmin" class="hide-from-small-578 notes-component__add-wrap">
                    <button class="blue-button notes-component__add-button" type="button" (click)="onOpenNote()">
                        {{ 'ADD_NOTE' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </header>

    <div class="datatable__body notes-component__body">
        <table class="datatable__table notes-component__table">
            <thead>
                <tr>
                    <th class="notes-component__col notes-component__col--status"></th>
                    <th class="notes-component__col notes-component__col--updated">{{ 'UPDATED' | translate }}</th>
                    <th class="notes-component__col notes-component__col--author">{{ 'AUTHOR' | translate }}</th>
                    <th *ngIf="isClientNotes()" class="notes-component__col notes-component__col--campaign">{{ 'CAMPAIGN' | translate }}</th>
                    <th class="notes-component__col notes-component__col--note">{{ 'NOTE' | translate }}</th>
                    <th *ngIf="iCanWrite || iCanDelete || iIsAdmin">{{ iHideActionColName ? '' : ('ACTIONS' | translate) }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="notesData.length==0">
                    <td class="notes-component__empty" [attr.colspan]="(isClientNotes() ? 5 : 4) + ((iCanWrite || iCanDelete || iIsAdmin) ? 1 : 0)">
                        {{ 'NO_DATA_FOUND' | translate }}
                    </td>
                </tr>
                <tr *ngFor="let note of tempNotesData; let i=index">
                    <td class="notes-component__status-cell">
                        <span *ngIf="note.isInternal == true"><i-feather [attr.title]="'INTERNAL' | translate" name="eye-off" class="notes-component__internal-icon"></i-feather></span>
                    </td>
                    <td class="notes-component__meta-cell color-anchor notes-component__meta-cell--center">
                        <p class="hide-from-small notes-component__mobile-label">{{ 'UPDATED' | translate }}: </p>{{note.updatedOn | P_AppDateFormat}}
                    </td>
                    <td class="notes-component__meta-cell color-anchor notes-component__meta-cell--center notes-component__author-cell">
                        <p class="hide-from-small notes-component__mobile-label">{{ 'AUTHOR' | translate }}: </p>{{note.assignedUserName}}
                    </td>
                    <td *ngIf="isClientNotes()" class="color-anchor notes-component__meta-cell notes-component__campaign-cell">
                        <p class="hide-from-small notes-component__mobile-label">{{ 'CAMPAIGN' | translate }}: </p>
                        <a *ngIf="note.campaignId" [routerLink]="['/pages/campaign-details', note.campaignId]"
                            class="notes-component__campaign-link">
                            {{note.campaignName}} &nbsp; <i-feather name="link" class="notes-component__campaign-link-icon"></i-feather>
                        </a>
                    </td>
                    <td class="notes-component__content-cell">
                        <div class="notes-component__content-stack">
                            <p class="hide-from-small notes-component__mobile-label notes-component__mobile-label--underlined">{{ 'NOTE' | translate }}: </p>
                            <label class="color-anchor notes-component__title">{{note.title}}</label>
                            <p class="color-anchor notes-component__description">{{note.description}}</p>
                            <div *ngFor="let file of note.noteFiles" class="notes-component__attachment-row">
                                <a (click)="getAttachmentUrl(note.id, file.name)" target="_blank"
                                    class="notes-component__attachment-link">
                                    {{file.name}}
                                    <i class="fas fa-download notes-component__attachment-icon"></i>
                                </a>
                            </div>
                        </div>
                    </td>
                    <td *ngIf="iCanWrite || iCanDelete || iIsAdmin" class="notes-component__actions-cell">
                        <a *ngIf="iCanWrite || iIsAdmin" class="a-btn notes-component__action-link" [routerLink]=""
                            (click)="onOpenNote(note.id);$event.stopPropagation();">
                            <i-feather name="edit"></i-feather>
                        </a>
                        <a *ngIf="iCanDelete || iIsAdmin" class="a-btn notes-component__action-link" [routerLink]=""
                            (click)="onDeleteNote(note.id);$event.stopPropagation();">
                            <i-feather name="x"></i-feather>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <footer class="datatable__footer notes-component__footer">
        <div class="datatable__pagination-group notes-component__pagination-group">
            <div class="datatable__pagination pagination-rounded notes-component__pagination">
                <ngb-pagination [maxSize]="1" [rotate]="true" [ellipses]="true"
                    [collectionSize]="notesData.length" [page]="pageNumber" [boundaryLinks]="true"
                    (pageChange)="onPageChange($event)" [pageSize]="pageSize">
                </ngb-pagination>
            </div>
        </div>
    </footer>
</section>
